// Modules
import React from 'react';

import { Page, PageHeader, PageContent } from 'components/page';

import useMfaConnection from './hooks/use-mfa-connection';
import MfaConnectionLog from './components/mfa-connection-log';


// Component
function MfaDeviceConnect({ routeParams }) {
  const deviceId = routeParams && routeParams.deviceId;
  const {
    device,
    isLoading,
    status,
    connectionEntries,
    isLoadingLog,
    setContainerRef,
    connect,
    disconnect
  } = useMfaConnection({ deviceId, isActive: true });

  if (isLoading) return null;

  const title = device ? device.name : 'MFA Connect';

  let backgroundColor = '#f44336';
  if (status === 'connected') backgroundColor = '#4caf50';
  else if (status === 'connecting') backgroundColor = '#ff9800';

  const headerActions = (
    <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginLeft: '15px' }}>
      <span
        style={{
          display: 'inline-block',
          width: 10,
          height: 10,
          borderRadius: '50%',
          backgroundColor
        }}
      />
      <span style={{ textTransform: 'capitalize' }}>{status}</span>
      { status !== 'connected' && status !== 'connecting' &&
        <button className="btn btn-sm btn-primary" onClick={() => connect()}>Reconnect</button>
      }
      { status === 'connected' &&
        <button className="btn btn-sm btn-default" onClick={disconnect}>Disconnect</button>
      }
    </div>
  );

  return (
    <Page className="mfa-connect-page">
      <PageHeader title={title} actions={headerActions} />
      <PageContent>
        <div style={{ display: 'flex', gap: 24, alignItems: 'flex-start' }}>
          <div
            ref={setContainerRef}
            style={{
              width: 'auto',
              aspectRatio: '9/20',
              height: 'calc(100vh - 220px)',
              background: '#1a1a1a',
              borderRadius: 8,
              flex: '0 0 auto'
            }}
          />
          <MfaConnectionLog entries={connectionEntries} isLoading={isLoadingLog} />
        </div>
      </PageContent>
    </Page>
  );
}


// Exports
export default MfaDeviceConnect;
